import { render, staticRenderFns } from "./JielongTitleCard.vue?vue&type=template&id=0a5f790c&scoped=true"
import script from "./JielongTitleCard.vue?vue&type=script&lang=ts"
export * from "./JielongTitleCard.vue?vue&type=script&lang=ts"
import style0 from "./JielongTitleCard.vue?vue&type=style&index=0&id=0a5f790c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5f790c",
  null
  
)

export default component.exports